/* eslint-disable no-underscore-dangle */
/* eslint-disable no-return-assign */
import React, { useState, useRef, useContext } from 'react';
import Router from 'next/router';
import PropTypes from 'prop-types';

import { TextInput, Form, Button } from 'components/common';
import maskAmount from 'utils/maskAmount';
import { UserContext } from 'contexts/userContext';
import { StatusContext } from 'contexts/statusContext';
import { withTranslation } from 'language/i18n';

const Bid = ({
  t, setMarketPlaceModalVisible, setCheckBidModalData,
}) => {
  const { isLoggedIn } = useContext(UserContext);
  const { setErrorState } = useContext(StatusContext);

  const [amount, setAmount] = useState('');
  const [unmaskedAmount, setUnmaskedAmount] = useState('');
  const [formRef, setFormRef] = useState(useRef());

  const handleAmount = ({ value }) => {
    const fixedInput = value.replace(/[^0-9]/g, '');

    const maskedAmountValue = maskAmount(fixedInput, 'EUR', true);

    formRef.setFieldsValue({
      amount: maskedAmountValue,
    });

    setAmount(maskedAmountValue);
    setUnmaskedAmount(fixedInput);
  };

  const makeBid = async () => {
    if (isLoggedIn) {
      if (amount > '0') {
        setCheckBidModalData({
          amount: unmaskedAmount,
        });

        formRef.setFieldsValue({
          amount: '',
        });
        setAmount('');
      } else if (amount <= '0') {
        setMarketPlaceModalVisible(true);
      }
    } else {
      setErrorState({
        title: t('alert'),
        text: 'Teklif verebilmeniz için giriş yapmanız gerekmektedir.',
        buttonText: t('login'),
        onClickButton: () => {
          setErrorState({});
          Router.push({
            pathname: '/login',
            query: {
              redirectTo: Router.asPath,
            },
          });
        },
      });
    }
  };

  return (
    <Form
      layout="horizontal"
      onFinish={makeBid}
      formRef={(ref) => setFormRef(ref)}
    >
      <div className="row mb-3">
        <div className="col-15 col-md-9 mb-3 mb-md-0">
          <div
            className="im-input im-input--type2 im-input--prefix"
            type="button"
            onClick={() => formRef.getFieldInstance('amount').focus()}
          >
            <div className="im-input__prefix">€</div>
            <TextInput
              name="amount"
              placeholder="Lütfen teklif tutarınızı giriniz."
              value={amount}
              onChange={handleAmount}
              formRef={formRef}
              style={{ fontSize: 18, width: '100%' }}
              hideLabel
              formItemStyle={{
                marginBottom: '0',
                width: '100%',
              }}
            />
          </div>
        </div>
        <div className="col-15 col-md-6 pl-md-0">
          <Button
            htmlType="submit"
            className="im-button im-button--primary im-button--fluid im-button--gutter-5 im-button--center im-button--size-60 fw-900 text-black1"
            label={t('makeOffer')}
          />
        </div>
      </div>
    </Form>
  );
};

Bid.propTypes = {
  t: PropTypes.func,
  setMarketPlaceModalVisible: PropTypes.func,
  setCheckBidModalData: PropTypes.func,
};

export default withTranslation('common')(Bid);
